import { UIText2 } from '@cian/ui-kit';

interface IFinishLabelProps {
  label: string;
}

export function FinishLabel({ label }: IFinishLabelProps) {
  return <UIText2 color="gray40_100">{label}</UIText2>;
}
